import React from "react";
import SideDetailsHeadToHead from "../../../Calendar/SideDetailsHeadToHead.jsx";
import ImageOrFlag from "../../../Common/MatchSideImageOrFlag.jsx";
import SportType from "../../../../common/Enums/SportType.js";

/**
 * Similar to MatchDetails modal but handles the per achievement details per round.
 */
const AchievementDetailsModal = ({
    achievements,
    details,
    sportsman,
    game,
    stage,
    onClose,
    isSingleSportsman = true,
    sidesDetails,
    sportType = null,
}) => {
    if (details == null) {
        return <></>;
    }

    if (isSingleSportsman) {
        var allRoundsTotal = details.reduce((carry, e) => carry + e.points, 0);
        
        var achievementsPerRound = details.reduce(function (r, a) {
            r[a.result_id] = r[a.result_id] || [];
            r[a.result_id].push(a);
            return r;
        }, Object.create(null));

        var header = `${sportsman} (${game})`;
    } else {
        if (sidesDetails == null) {
            return <></>;
        }

        let detailsSideA = details['sideA'];
        let detailsSideB = details['sideB'];

        if (detailsSideA.length > 0 && detailsSideB.length > 0) {
            var achievementsPerRound = details['sideA'].reduce(function (r, a, idx) {
                r[a.result_id] = r[a.result_id] || [];
                r[a.result_id]['roundTitle'] = r[a.result_id]['roundTitle'] || '';
                r[a.result_id]['sideA'] = r[a.result_id]['sideA'] || [];
                r[a.result_id]['sideB'] = r[a.result_id]['sideB'] || [];
                r[a.result_id]['sideA'].push(a);
                r[a.result_id]['sideB'].push(details['sideB'][idx])
                r[a.result_id]['roundTitle'] = a.round;
                return r;
            }, Object.create(null));
    
            sidesDetails['sideA']['countryCode'] = sidesDetails['sideA']['country'];
            sidesDetails['sideB']['countryCode'] = sidesDetails['sideB']['country'];

            let scorePropertyName = isNbaTypeSport(sportType) ? 'details' : 'result';

            var header = <div className="game-details-header">
                <ImageOrFlag side={sidesDetails.sideA}/>{`${sidesDetails.sideA.name}`}
                <strong className="result-points">{sidesDetails.sideA[scorePropertyName]} : {sidesDetails.sideB[scorePropertyName]}</strong>
                <ImageOrFlag side={sidesDetails.sideB}/>{`${sidesDetails.sideB.name}`}
                <div>{formatPartResults(sidesDetails.sideA.details, sidesDetails.sideB.details, sportType)}</div>
            </div>
        } else {
            // Or any sports that wont use the elements below
            // TO DO: Refactor by making this a whole separate component
            if (
                !isNbaTypeSport(sportType)
            ) {
                // If side A is Bye
                if (detailsSideA.length == 0) {
                    var achievementsPerRound = details['sideB'].reduce(function (r, a, idx) {
                        r[a.result_id] = r[a.result_id] || [];
                        r[a.result_id]['roundTitle'] = r[a.result_id]['roundTitle'] || '';
                        r[a.result_id]['sideB'] = r[a.result_id]['sideB'] || [];
                        r[a.result_id]['sideB'].push(details['sideB'][idx])
                        r[a.result_id]['roundTitle'] = a.round;
                        return r;
                    }, Object.create(null));
            
                    sidesDetails['sideB']['countryCode'] = sidesDetails['sideB']['country'];
            
                    var header = <div className="game-details-header">
                        <ImageOrFlag side={sidesDetails.sideB}/>{`${sidesDetails.sideB.name}`}
                        <div>{formatPartResults(sidesDetails.sideA.details, sidesDetails.sideB.details, sportType)}</div>
                    </div>
                }

                // If side B  is Bye
                if (detailsSideB.length == 0) {
                    var achievementsPerRound = details['sideA'].reduce(function (r, a, idx) {
                        r[a.result_id] = r[a.result_id] || [];
                        r[a.result_id]['roundTitle'] = r[a.result_id]['roundTitle'] || '';
                        r[a.result_id]['sideA'] = r[a.result_id]['sideA'] || [];
                        r[a.result_id]['sideA'].push(details['sideA'][idx])
                        r[a.result_id]['roundTitle'] = a.round;
                        return r;
                    }, Object.create(null));
            
                    sidesDetails['sideA']['countryCode'] = sidesDetails['sideA']['country'];
            
                    var header = <div className="game-details-header">
                        <ImageOrFlag side={sidesDetails.sideA}/>{`${sidesDetails.sideA.name}`}
                        <div>{formatPartResults(sidesDetails.sideA.details, sidesDetails.sideB.details, sportType)}</div>
                    </div>
                }
            }
        }
    }

    return <div id="matchModal" className="modal game-details-modal" role="dialog" style={{display: 'block'}}>
        <div className="modal-dialog results-match-modal" style={{  width: isSingleSportsman && '40%' }}>
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title text-center">
                        { header }
                    </h4>
                    { isSingleSportsman && 
                        <h4 className="modal-title text-center">
                            { stage }
                        </h4>
                    }
                </div>
                <div className="modal-body">
                    { isSingleSportsman ?
                        (<>
                            <div className="row">
                                <div className="col-xs-12">
                                    <span style={{ fontWeight: '700', fontSize: '1.5rem' }}>Overall Total: { allRoundsTotal }</span>
                                </div>
                            </div>
                            <div className="row" style={{ maxHeight: '400px', overflow: 'auto' }}>                        {/* Loop through each round's result */}
                                {Object.keys(achievementsPerRound).map((key, i) => (
                                    <div className="col-xs-12" style={{ marginBottom: '2rem' }}>
                                        <p style={{ 
                                                fontWeight: '600', 
                                                fontSize: '1.5rem',
                                                margin: '0',
                                                padding: '0.3rem 0',
                                                background: '#e55c27',
                                                textAlign: 'center',
                                                color: 'white',
                                                borderTopLeftRadius: '2.3px',
                                                borderTopRightRadius: '2.3px',
                                                display: isNbaTypeSport(sportType) ? 'none' : 'block'
                                            }}
                                        >
                                            { achievementsPerRound[key][0]['round'] }
                                        </p>
                                        <SideDetailsHeadToHead 
                                            achievements={achievements} 
                                            details={achievementsPerRound[key]} 
                                            isScheduledGame={true}
                                        />
                                    </div>
                                ))}
                            </div>
                        </>) :
                        (
                            <div>
                                {Object.keys(achievementsPerRound).map((key, i) => (
                                    <div key={key} className="row" style={
                                        (
                                            (! achievementsPerRound[key].hasOwnProperty('sideA')) ||
                                            (! achievementsPerRound[key].hasOwnProperty('sideB'))
                                        )
                                        ?
                                        {
                                            display: 'flex',
                                            justifyContent: 'center'
                                        } 
                                        :
                                        {}
                                    }>
                                        <div className={
                                            (
                                                (achievementsPerRound[key].hasOwnProperty('sideA') && achievementsPerRound[key]['sideA'].length > 0) &&
                                                (achievementsPerRound[key].hasOwnProperty('sideB') && achievementsPerRound[key]['sideB'].length > 0)
                                            )
                                            ?
                                            'col-12' : 'col-xs-6'
                                        }>
                                            {/* Tables */}
                                            <div className="row" style={{ margin: '0 auto' }}>
                                                <div className="col-12">
                                                    {/* Round Header */}
                                                    <p style={{ 
                                                        fontWeight: '600', 
                                                        fontSize: '1.5rem',
                                                        margin: '0',
                                                        padding: '0.3rem 0',
                                                        background: '#e55c27',
                                                        textAlign: 'center',
                                                        color: 'white',
                                                        borderTopLeftRadius: '2.3px',
                                                        borderTopRightRadius: '2.3px',
                                                        display: isNbaTypeSport(sportType) ? 'none' : 'block'
                                                    }}
                                                    >
                                                        { achievementsPerRound[key]['roundTitle'] }
                                                    </p>
                                                </div>
                                                {
                                                    (achievementsPerRound[key].hasOwnProperty('sideA') && achievementsPerRound[key]['sideA'].length > 0) &&
                                                    <div className={
                                                            (
                                                                achievementsPerRound[key].hasOwnProperty('sideB') &&
                                                                achievementsPerRound[key]['sideB'].length > 0
                                                            )
                                                            ? 'col-xs-6' : 'col-12'
                                                        }
                                                        style={{
                                                            paddingLeft: 
                                                                (
                                                                    (achievementsPerRound[key].hasOwnProperty('sideA')) &&
                                                                    (achievementsPerRound[key].hasOwnProperty('sideB'))
                                                                ) ? '0' : ''
                                                        }}
                                                    >
                                                        <SideDetailsHeadToHead
                                                            achievements={achievements}
                                                            details={achievementsPerRound[key]['sideA']}
                                                        />
                                                    </div>
                                                }
                                                {
                                                    (achievementsPerRound[key].hasOwnProperty('sideB') && achievementsPerRound[key]['sideB'].length > 0) &&
                                                    <div className={
                                                            (
                                                                achievementsPerRound[key].hasOwnProperty('sideA') &&
                                                                achievementsPerRound[key]['sideA'].length > 0
                                                            )
                                                            ? 'col-xs-6' : 'col-12'
                                                        }
                                                        style={{
                                                            paddingRight: 
                                                                (
                                                                    (achievementsPerRound[key].hasOwnProperty('sideA')) &&
                                                                    (achievementsPerRound[key].hasOwnProperty('sideB'))
                                                                ) ? '0' : ''
                                                        }}
                                                    >
                                                        <SideDetailsHeadToHead
                                                            achievements={achievements}
                                                            details={achievementsPerRound[key]['sideB']}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </div>
                <div className="modal-footer">
                    <button onClick={onClose} type="button" className="btn-orange btn-flex-bs btn-modal-ok">OK</button>
                </div>
            </div>
        </div>
    </div>;
};

const formatPartResults = (resultA, resultB, sportType) => {
    if (isNbaTypeSport(sportType)) {
        return '';
    }

    resultA = resultA.split(" ");
    resultB = resultB.split(" ");

    let newRes = '';
    resultA.forEach((el, idx) => {
        newRes += `${el}-${resultB[idx]}, `;
    })

    return newRes.replace(/,\s*$/, "");
}

const isNbaTypeSport = (sport) => {
    return [
        SportType.FOOTBALL,
        SportType.AMERICAN_FOOTBALL,
        SportType.BASKETBALL,
    ].includes(sport);
}

export default AchievementDetailsModal;